import React from "react";

const Menu = ({ ...rest }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="menu-05">
                <path
                    id="Icon"
                    d="M3 8.5H21M3 15.5H21"
                    stroke="#0F1016"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
};

export default Menu;
